export const isWebView = (): boolean =>
  typeof window !== 'undefined' &&
  !!(window as Window & { ReactNativeWebView?: unknown }).ReactNativeWebView

export const isIframe = (): boolean =>
  typeof window !== 'undefined' && window.self !== window.top

const EMBED_SHELL_KEY = 'qsc.embedShell'

function readShellMode(): string | null {
  if (typeof window === 'undefined') return null
  const params = new URLSearchParams(window.location.search)
  const shell = params.get('shell')
  if (shell) {
    try {
      window.sessionStorage.setItem(EMBED_SHELL_KEY, shell)
    } catch {
      // Embedded storage can be unavailable; the current URL still wins.
    }
    return shell
  }

  try {
    return window.sessionStorage.getItem(EMBED_SHELL_KEY)
  } catch {
    return null
  }
}

export const isEmbeddedAppShell = (): boolean => isWebView() && readShellMode() === 'app'

export const usesHostSession = (): boolean => {
  if (typeof window === 'undefined') return false
  const params = new URLSearchParams(window.location.search)
  return isWebView() || isIframe() || params.get('embed') === '1'
}

export const hasHostShell = (): boolean => usesHostSession() && !isEmbeddedAppShell()

export const isEmbedded = hasHostShell

export const showEmbedChrome = (): boolean => {
  if (typeof window === 'undefined') return false
  const params = new URLSearchParams(window.location.search)
  return hasHostShell() && params.get('embedChrome') === '1'
}
